import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.analysisComponents;

export default class AnalysisComponents extends Model {
  static entity = `${ name }`;
  static primaryKey = 'trial_id';

  static fields() {
    return {
      trial_id: this.attr(null),
      components: this.attr([]),
    };
  }

  static methodConf = {
    http: {
      url: '/modules/analysis',
    },
    methods: {
      $get: {
        name: 'get',
        http: {
          url: '/:id/components',
          method: 'get',
        },
      },
    },
  };
}
